
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/container",
      function () {
        return require("private-next-pages/templates/container.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates/container"])
      });
    }
  